import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Promo from "../../assets/img/promo-announcement.json";
import IconBeta from "../../assets/img/icon-beta.svg";
import PlayStoreButton from "../../assets/img/btn-playstore.png";
import PromoImg from "../../assets/img/promo-img.png";
import Lottie from "react-lottie-player";
import LogoOneZapp from "../../assets/img/brand-logo.svg";
import closei from "../../assets/img/Overlay close icon.svg";
import { useEffect } from "react";

export const PromoDialog = () => {
  const [show, setShow] = useState(false);

  var object = {
    value: "OneZapp Revamp Promo",
    timestamp: new Date().getTime(),
  };

  const handleClose = () => {
    setShow(false);
    // adding new local storage
    localStorage.setItem("oz-promo", JSON.stringify(object));
  };

  useEffect(() => {
    // remove old local storage
    if (localStorage.getItem("oz-promo-viewed")) {
      localStorage.removeItem("oz-promo-viewed");
    } else if (!localStorage.getItem("oz-promo")) {
      setShow(true);
    }
  }, [localStorage]);

  return (
    <>
      <Modal
        className="promo-dialog"
        show={show}
        onHide={handleClose}
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title>
            <span className="logo-wrap">
              <img src={LogoOneZapp} alt="logo onezapp" height={40} />
            </span>
          </Modal.Title>
          <button
            type="button"
            className="close-btn"
            style={{
              background: "transparent",
              border: "transparent",
            }}
            onClick={(e) => handleClose(e)}
          >
            <img className="img-close color-white" src={closei} />
          </button>
        </Modal.Header>
        <Modal.Body>
          {/* <Lottie
            loop
            animationData={Promo}
            play
            style={{ width: 200, height: 200 }}
          /> */}
          <div className="row align-items-center">
            <div className="col-lg-7">
              <h1 className="text-start">
                “Reimagined Excellence: Elevating User Interface and User
                Experience”
              </h1>
            </div>
            <div className="col-lg-5">
              <img className="img-promo" src={PromoImg} alt="promo img" />
            </div>
          </div>

          {/* <h1>
            OneZapp{" "}
            <sup>
              <img src={IconBeta} alt="onezapp beta version" />
            </sup>{" "}
            is here!
          </h1>
          <a
            // className="btn bg-purple btn-rounded"
            target="_blank"
            href="https://play.google.com/store/apps/details?id=com.epSystems.oneZap.android.app"
          >
            <img
              src={PlayStoreButton}
              alt="Download OneZapp Play Store"
              width={150}
            />
          </a> */}
        </Modal.Body>
      </Modal>
    </>
  );
};
